/* PPF-Kits: Verhalten der eigenen Varianten-Kacheln (snippets/pk-variant-cards.liquid).
   - "Mehr anzeigen": Zustand als Attribut data-pk-vc-open am <variant-selects>, weil Dawn beim
     Variantenwechsel nur dessen Inhalt ersetzt (der Zustand bleibt so erhalten).
   - Liegt die gewählte Kachel im eingeklappten Bereich, wird automatisch aufgeklappt.
   - Nach einer Auswahl zum Produktkopf scrollen, wenn er nicht sichtbar ist (wie früher bei EVS). */
(function () {
  if (window.__pkVariantCards) return;
  window.__pkVariantCards = true;

  /* Dawn ersetzt beim Variantenwechsel das ganze <variant-selects>-Element (HTMLUpdateUtility.viewTransition),
     daher lebt der Zustand hier und wird auf jedes neue Element übertragen */
  var STATE = { open: false };
  function applyState(vs) {
    if (!vs) return;
    if (STATE.open) vs.setAttribute('data-pk-vc-open', ''); else vs.removeAttribute('data-pk-vc-open');
  }

  function syncMore(vs) {
    if (!vs) return;
    var fs = vs.querySelector('[data-pk-vc]');
    if (!fs) return;
    var checked = fs.querySelector('input[type="radio"]:checked');
    var item = checked && checked.closest('.pk-vc__item');
    if (item && !vs.hasAttribute('data-pk-vc-open') && item.offsetParent === null) {
      vs.setAttribute('data-pk-vc-open', '');
      STATE.open = true;
    }
    var btn = fs.querySelector('[data-pk-vc-more]');
    if (btn) btn.setAttribute('aria-expanded', vs.hasAttribute('data-pk-vc-open') ? 'true' : 'false');
  }

  function syncAll() {
    document.querySelectorAll('variant-selects').forEach(function (vs) { syncMore(vs); });
  }

  /* Auf-/Zuklappen mit weicher Höhen-Animation (Web Animations API); neue Kacheln blenden gestaffelt ein */
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2, .8, .2, 1)';
  function hidden(items) { return items.filter(function (i) { return i.offsetParent === null; }); }
  function animateHeight(grid, from, to, done) {
    if (REDUCED || !grid.animate || from === to) { if (done) done(); return; }
    grid.style.overflow = 'hidden';
    // Dauer wächst mit der Höhe, die dazukommt (User 04.10.2026): wenige Zeilen ca. 0,4 s, viele Zeilen (z. B. Tesla Model Y am Handy) bis 1,5 s;
    // bei großen Strecken sanfterer Start, damit die Seite nicht "nach unten rast"
    var dist = Math.abs(to - from);
    var dur = Math.min(1500, Math.max(420, 300 + dist * 0.9));
    var ease = dist > 500 ? 'cubic-bezier(.33, .05, .2, 1)' : EASE;
    var a = grid.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: dur, easing: ease });
    lastDur = dur;
    var fin = false;
    a.onfinish = a.oncancel = function () { if (fin) return; fin = true; grid.style.overflow = ''; if (done) done(); };
    // Sicherheitsnetz: in Hintergrund-Tabs frieren Animationen ein -> nach 800 ms sicher beenden
    // (cancel() meldet sich dort ebenfalls erst im nächsten Frame -> direkt aufräumen statt auf oncancel zu warten)
    setTimeout(function () {
      if (fin) return;
      fin = true; a.cancel(); grid.style.overflow = ''; if (done) done();
    }, dur + 400);
  }
  var lastDur = 420;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pk-vc-more]');
    if (!btn) return;
    var vs = btn.closest('variant-selects');
    if (!vs) return;
    var fs = btn.closest('[data-pk-vc]');
    var grid = fs && fs.querySelector('.pk-vc__grid');
    var items = grid ? Array.prototype.slice.call(grid.querySelectorAll('.pk-vc__item')) : [];
    if (vs.hasAttribute('data-pk-vc-open')) {
      // zuklappen: Zielhöhe messen, Kacheln bis zum Ende der Animation sichtbar lassen
      var hOpen = grid ? grid.offsetHeight : 0;
      vs.removeAttribute('data-pk-vc-open');
      var hShut = grid ? grid.offsetHeight : 0;
      vs.setAttribute('data-pk-vc-open', '');
      STATE.open = false;
      btn.setAttribute('aria-expanded', 'false');
      var top = fs && fs.getBoundingClientRect().top;
      if (fs && top < 0) fs.scrollIntoView({ block: 'start', behavior: 'smooth' });
      if (grid) animateHeight(grid, hOpen, hShut, function () { if (!STATE.open) vs.removeAttribute('data-pk-vc-open'); });
      else vs.removeAttribute('data-pk-vc-open');
    } else {
      var hidd = hidden(items);
      var h0 = grid ? grid.offsetHeight : 0;
      vs.setAttribute('data-pk-vc-open', '');
      STATE.open = true;
      btn.setAttribute('aria-expanded', 'true');
      if (!grid) return;
      var h1 = grid.offsetHeight;
      animateHeight(grid, h0, h1);
      if (!REDUCED && hidd.length && hidd[0].animate) {
        // Kacheln blenden im Takt der wachsenden Höhe ein: Gesamtstaffel ca. 55 % der Dauer, pro Kachel höchstens 70 ms Versatz
        var step = Math.min(70, (lastDur * 0.55) / Math.max(1, hidd.length));
        var itDur = Math.min(520, Math.max(320, lastDur * 0.4));
        hidd.forEach(function (it, k) {
          it.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }],
            { duration: itDur, delay: 60 + k * step, easing: EASE, fill: 'backwards' });
        });
      }
    }
  });

  function inView(el, margin) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top >= margin && r.bottom <= vh - margin;
  }
  function stickyOffset() {
    var h = document.querySelector('.shopify-section-header-sticky, .header-wrapper');
    if (!h) return 0;
    var cs = getComputedStyle(h.closest('.shopify-section-header-sticky') || h);
    return cs.position === 'sticky' || cs.position === 'fixed' ? h.getBoundingClientRect().height : 0;
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-pk-vc]')) return;
    var info = t.closest('.product__info-container') || document;
    var title = info.querySelector('.product__title');
    if (!title || inView(title, 24)) return;
    setTimeout(function () {
      var y = title.getBoundingClientRect().top + window.scrollY - stickyOffset() - 8;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }, 80);
  });

  /* Folienkarten: die Trennlinie der Eigenschaften (.pkac-specs) muss unter dem absolut positionierten Folienbild
     liegen. Der Kopf (Titel, Preis, Streichpreis) ist je Karte unterschiedlich hoch -> Abstand je Karte nachmessen */
  var cardT = null;
  function fixCardSpacing() {
    document.querySelectorAll('.mw-option--type-swatchcard .mw-label__card-wrapper').forEach(function (w) {
      var media = w.querySelector('.mw-stack--card__media-wrapper');
      var specs = w.querySelector('.pkac-specs');
      if (!media || !specs || !media.offsetHeight) return;
      specs.style.removeProperty('margin-top');
      var need = media.getBoundingClientRect().bottom + 16 - specs.getBoundingClientRect().top;
      if (need > 0) {
        var cur = parseFloat(getComputedStyle(specs).marginTop) || 0;
        specs.style.setProperty('margin-top', (cur + need) + 'px', 'important');
      }
    });
  }
  function schedCards() { clearTimeout(cardT); cardT = setTimeout(fixCardSpacing, 60); }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.closest && t.closest('.mw-option--type-swatchcard') || (t.querySelector && t.querySelector('.mw-option--type-swatchcard'))) { schedCards(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', schedCards);
  window.addEventListener('load', schedCards);

  function syncNew() {
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      if (vs.__pkSynced) return;
      vs.__pkSynced = true;
      applyState(vs);
      syncMore(vs);
      // Kit-Folienkarten: Stil, Eigenschaften und Punkte von pk_apo_cards auf das neue Element anwenden
      if (vs.classList.contains('mw-apo-container') && typeof window.__pkacBoot === 'function') {
        window.__pkacBoot();
        setTimeout(window.__pkacBoot, 120);
      }
    });
  }
  function init() {
    syncNew();
    // neue <variant-selects> nach dem Variantenwechsel sofort mit dem gemerkten Zustand versehen
    new MutationObserver(function () { syncNew(); }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Produktgalerie: nur die Bilder der aktuellen Auswahl (User 04.10.2026).
   Gezeigt werden das Bild der gewählten Variante und alle Bilder, die zu KEINER anderen Variante gehören (Werkzeug, Montage, Belegbild ...).
   "Zu einer anderen Variante gehörig" = Bild ist deren Variantenbild ODER hat denselben Alt-Text wie das Variantenbild einer anderen Variante
   (bei den Kits hängt nur das erste Bild je Konfiguration an der Variante, die weiteren tragen nur den gleichen Alt-Text).
   Dawn aktualisiert beim Variantenwechsel nur die großen Slides, nicht die Thumbnails -> hier für beide gleich gelöst; das Thumbnail der
   gewählten Variante rückt nach vorn. Ausgeblendet wird per Attribut data-pk-hide (CSS in pk-variant-cards.css). */
(function () {
  if (window.__pkGalleryFilter) return;
  window.__pkGalleryFilter = true;

  var P = null;
  function productData() {
    if (P) return P;
    var el = document.getElementById('pk-gallery-data');
    if (!el) return null;
    try { P = JSON.parse(el.textContent); } catch (e) { P = null; }
    return P;
  }
  function currentVariantId() {
    var i = document.querySelector('product-info input[name="id"]');
    return i ? Number(i.value) : null;
  }
  function idOf(el) {
    var raw = el.getAttribute('data-media-id') || el.getAttribute('data-target') || '';
    return raw.split('-').pop();
  }
  function altOf(el) {
    var img = el.querySelector('img');
    return img ? (img.getAttribute('alt') || '') : '';
  }

  function apply() {
    var p = productData();
    if (!p || !p.variants || !p.variants.length) return;
    var vid = currentVariantId();
    var cur = null;
    p.variants.forEach(function (v) { if (v.id === vid) cur = v; });
    if (!cur) cur = p.variants[0];
    var fm = cur.fm;
    var curId = fm ? String(fm.id) : '';
    var curAlt = fm && fm.alt ? fm.alt : '';
    var otherIds = {}, otherAlts = {};
    if (fm) {
      p.variants.forEach(function (v) {
        var m = v.fm;
        if (!m) return;
        var mid = String(m.id);
        if (mid !== curId) otherIds[mid] = true;
        if (m.alt && m.alt !== curAlt) otherAlts[m.alt] = true;
      });
    }
    function foreign(el) {
      if (!fm) return false;
      var id = idOf(el), alt = altOf(el);
      return !!((otherIds[id] && id !== curId) || (alt && otherAlts[alt] && alt !== curAlt));
    }
    function mark(el) {
      var f = foreign(el);
      if (f && !el.hasAttribute('data-pk-hide')) el.setAttribute('data-pk-hide', '');
      else if (!f && el.hasAttribute('data-pk-hide')) el.removeAttribute('data-pk-hide');
    }
    var gal = document.querySelector('media-gallery');
    if (!gal) return;
    gal.querySelectorAll('li[data-media-id]').forEach(mark);
    var thumbs = gal.querySelectorAll('li[data-target]');
    thumbs.forEach(function (t) {
      t.classList.remove('thumbnail-list_item--variant');   // Dawn blendet sonst alle Variantenbilder außer dem ersten fest aus
      mark(t);
    });
    if (curId && thumbs.length) {
      var list = thumbs[0].parentNode, first = null;
      thumbs.forEach(function (t) { if (!first && idOf(t) === curId) first = t; });
      if (first && list.firstElementChild !== first) list.insertBefore(first, list.firstElementChild);
    }
    document.querySelectorAll('.product-media-modal__content [data-media-id]').forEach(mark);
  }

  var t = null;
  function sched() { clearTimeout(t); t = setTimeout(apply, 40); }

  function init() {
    apply();
    [250, 900, 2000].forEach(function (d) { setTimeout(apply, d); });
    // Variantenwechsel: Eingabe sofort, danach nach dem Nachladen der Slides noch einmal
    document.addEventListener('change', function (e) {
      var n = e.target && e.target.name;
      if (n === 'id') { apply(); [200, 600, 1200].forEach(function (d) { setTimeout(apply, d); }); }
    });
    try { if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.variantChange, function () { sched(); setTimeout(apply, 250); }); } catch (e) {}
    var gal = document.querySelector('media-gallery');
    if (gal) new MutationObserver(sched).observe(gal, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Kit-Konfiguration: der gewählte Wert erscheint sofort in der Zeile (Dawn setzt die Zeile danach ohnehin neu). */
document.addEventListener('change', function (e) {
  var s = e.target;
  if (!s || !s.classList || !s.classList.contains('pk-cfg__control') || !s.selectedOptions.length) return;
  var v = s.closest('.pk-cfg__row') && s.closest('.pk-cfg__row').querySelector('.pk-cfg__val');
  if (v) v.textContent = s.selectedOptions[0].textContent.replace(/\s+/g, ' ').trim();
}, true);

/* Kit-Beschreibung: "Included in this kit" klappt unter der Merkmale-Karte auf; an Optionen gebundene Teile (z. B. "Roof (With roof)")
   erscheinen nur, wenn die Option gewaehlt ist, und die Teilezahl in "Full Coverage" geht mit. Optionswerte je Variante: #pk-gallery-data. */
(function () {
  if (window.__pkInclInit) return;
  window.__pkInclInit = true;

  // Popup "Included in this kit" (Optik wie das Werkzeug-Popup, eigene Hooks data-pk-incl-*)
  function unlock() { document.documentElement.classList.remove('pk-tools-locked'); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var d = document.querySelector('[data-pk-incl-dlg]');
    if (t.closest('[data-pk-incl-open]')) {
      if (!d || d.open) return;
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      document.documentElement.classList.add('pk-tools-locked');
      return;
    }
    if (t.closest('[data-pk-incl-close]')) { if (d && d.open) d.close(); unlock(); return; }
    if (d && t === d) {
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { d.close(); unlock(); }
    }
  });
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-pk-incl-dlg]')) unlock();
  }, true);

  function currentOptions() {
    var el = document.getElementById('pk-gallery-data');
    if (!el) return null;
    var data; try { data = JSON.parse(el.textContent); } catch (err) { return null; }
    var inp = document.querySelector('product-info input[name="id"]');
    var vid = inp ? Number(inp.value) : null;
    var found = null;
    (data.variants || []).forEach(function (v) { if (v.id === vid) found = v; });
    return found && found.o ? found.o : null;
  }
  function applyIncl() {
    var items = document.querySelectorAll('[data-pk-incl-panel] li[data-pk-cond]');
    var cnt = document.querySelector('[data-pk-count]');
    if (!items.length || !cnt) return;
    var opts = currentOptions();
    if (!opts) return;
    items.forEach(function (li) { li.hidden = opts.indexOf(li.getAttribute('data-pk-cond')) === -1; });
    cnt.textContent = String(document.querySelectorAll('[data-pk-incl-panel] li:not([hidden])').length);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') { applyIncl(); [200, 700, 1400].forEach(function (d) { setTimeout(applyIncl, d); }); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyIncl); else applyIncl();
  setTimeout(applyIncl, 600);
})();
